import * as Sentry from "@sentry/nextjs";

let lastRequestId: string | null = null;

export function getLastApiRequestId(): string | null {
  return lastRequestId;
}

export function rememberRequestIdFromResponse(res: Response): void {
  const id = res.headers.get("X-Request-Id") ?? res.headers.get("x-request-id");
  if (id && id.trim().length > 0) {
    lastRequestId = id.trim();
    if (process.env["NEXT_PUBLIC_SENTRY_DSN"]) {
      Sentry.setTag("request_id", lastRequestId);
    }
  }
}
